import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Typography, Tag, Skeleton } from 'antd';
import { TrophyOutlined, TeamOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import api from '../../services/api';

const { Title, Text } = Typography;

// Hero simples para a landing do organizador: nome do time + próximo jogo + stats.
// Reaproveita os endpoints já existentes (/team-config e /organizer-games) — sem tocar no backend.
const OrganizerHero = () => {
  const [teamName, setTeamName] = useState(null);
  const [nextGame, setNextGame] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const [teamConfigRes, gamesRes] = await Promise.all([
          api.get('/team-config'),
          api.get('/organizer-games'),
        ]);

        if (!mounted) return;

        setTeamName(teamConfigRes.data?.game_name || null);

        const games = Array.isArray(gamesRes.data) ? gamesRes.data : [];
        // Status do game eh ABERTO (nao ATIVO — ATIVO eh do customer).
        const active = games.find((g) => g.status === 'ABERTO') || null;
        setNextGame(active);
      } catch (error) {
        // Falha silenciosa: hero é um complemento visual, não deve travar a tela.
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <Card className="card-premium" style={{ marginBottom: 24, border: 'none' }}>
        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
    );
  }

  return (
    <Card
      className="card-premium brand-gradient"
      style={{ marginBottom: 24, border: 'none', color: '#fff' }}
      styles={{ body: { padding: 24 } }}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} md={10}>
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>Bem-vindo de volta</Text>
          <Title level={3} style={{ color: '#fff', margin: '4px 0 0' }}>
            {teamName || 'Seu time'}
          </Title>
          {nextGame ? (
            <Tag icon={<ClockCircleOutlined />} color="rgba(255,255,255,0.25)" style={{ marginTop: 8, color: '#fff', border: 'none' }}>
              Próximo jogo: {nextGame.name}
            </Tag>
          ) : (
            <Tag color="rgba(255,255,255,0.25)" style={{ marginTop: 8, color: '#fff', border: 'none' }}>
              Nenhum jogo ativo no momento
            </Tag>
          )}
        </Col>
        <Col xs={24} md={14}>
          <Row gutter={16}>
            <Col span={8}>
              <Statistic
                title={<span style={{ color: 'rgba(255,255,255,0.85)' }}>Confirmados</span>}
                value={nextGame?.vai_jogar || 0}
                valueStyle={{ color: '#fff' }}
                prefix={<CheckCircleOutlined />}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title={<span style={{ color: 'rgba(255,255,255,0.85)' }}>Na espera</span>}
                value={nextGame?.espera || 0}
                valueStyle={{ color: '#fff' }}
                prefix={<TeamOutlined />}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title={<span style={{ color: 'rgba(255,255,255,0.85)' }}>Sem resposta</span>}
                value={nextGame?.nao_confirmado || 0}
                valueStyle={{ color: '#fff' }}
                prefix={<TrophyOutlined />}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default OrganizerHero;
